import styled from 'styled-components'
import { ContentBlockList } from '../ContentBlockList/styled'

export { ContentBlockList }

export const ItemName = styled.div`
    display: flex;
    align-items: center;

    color: #fff;
    font-weight: 500;
    margin: 5px 0 0;

    span {
        flex: 1;
        background-color: #666;
        padding: 5px;
    }

    button {
        margin-left: 5px;
        flex: 0;
        padding-top: 2px;
        padding-bottom: 3px;
        border-radius: 0;
    }
`

export const LibraryBlock = styled.li`
    .component-border {
        border-style: none;
    }

    .ory-toolbar-draggable > .ory-row > .ory-cell {
        background-color: #ffffff;
    }

    .ory-toolbar-draggable {
        width: 100%;
    }

    .ory-cell-inner {
        color: ${props => props.theme.admin.colors.brandDark};
        font-size: 0.2em;
        overflow: hidden;

        p {
            font-size: 2em;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 4;
            -webkit-box-orient: vertical;
            max-height: 90px;
            text-overflow: -o-ellipsis-lastline;
            margin-bottom: 2px;
        }

        .component-wrapper {
            pointer-events: none;

            * {
                font-size: 10px !important;
                min-height: 0;
                max-height: 100%;

                &[class*='cBand'] {
                    padding-top: 5px;
                    padding-bottom: 5px;

                    .btn-group {
                        transform: scale(0.4);
                    }

                    .col-xl-7 {
                        flex: 0 0 100%;
                        max-width: 100%;
                    }
                }
            }

            h1,
            h2,
            h3,
            h4,
            h5,
            h6 {
                margin-top: 1rem;
            }
        }
    }
`
